'use strict';

intellidealerAppCoreModule.filter('cdkDate', function ($filter, locationService) {
  return function (input) {
    var format = !locationService.isOtherwiseCountry()? 'MM-dd-yyyy' : 'dd-MM-yyyy';
    return input? $filter('date')(input, format) : '';
  };
});
